import React, { useState, useEffect } from "react";
import Slider from "./Slider";
import List from "./List";
import Button from "./Button";
import Select from "react-select";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setActiveItem } from "../app/reducers/activePage";

const Header = () => {
  const [humbugerclass, sethumbergerClass] = useState("humbergerdiv");
  const [reponisveMenu, setResponsiveMenu] = useState(false);
  const activepage = useSelector((state) => state.activepage);
  const dispatch = useDispatch();
  const burgerAnimation = (e) => {
    e.stopPropagation();
    if (humbugerclass == "humbergerdiv") {
      sethumbergerClass("cross");
      setResponsiveMenu(true);
    } else {
      sethumbergerClass("humbergerdiv");
      setResponsiveMenu(false);
    }
  };

  useEffect(() => {
    // Iterate over each object in the data array

    function handleClick() {
      setResponsiveMenu(false);
      sethumbergerClass("humbergerdiv");
    }
    document.body.addEventListener("click", handleClick);

    return () => {
      // 👇️ remove event listener when the component unmounts
      document.body.removeEventListener("click", handleClick);
    };
  }, []);

  const pages = [
    {
      name: "Buy",
      url: "/buy",
      subcategories: false,
    },
    {
      name: "Rent",
      url: "/rent",
      subcategories: false,
    },
    {
      name: "Agents",
      url: "/agents",
      subcategories: false,
    },
    // {
    //   name: "Properties",
    //   url: "/properties",
    //   subcategories: false,
    // },
    // {
    //   name: "Property Type",
    //   subcategories: true,
    //   items: [
    //     {
    //       name: "Rent",
    //       url: "/rent", // Add the URL property for the "Rent" item
    //     },
    //     {
    //       name: "Buy",
    //       url: "/buy", // Add the URL property for the "Buy" item
    //     },
    //   ],
    // },
    {
      name: "Projects",
      url: "/Newproject",
      subcategories: false,
    },
    // {
    //   name: "find an Agency",
    //   url: "/findanagency",
    //   subcategories: false,
    // },

    // {
    //   name: "Trends",
    //   url: "/trends",
    //   subcategories: false, // Add the URL property for the "Rent" item
    // },
    // {
    //   name: "Prices",
    //   url: "/prices",
    //   subcategories: false, // Add the URL property for the "Buy" item
    // },

    // {
    //   name: "Agency Portal",
    //   url: "/Agencyportal",
    //   subcategories: false,
    // },
    {
      name: "Blogs",
      url: "/blogs",
      subcategories: false,
    },
  ];

  const options = [
    { value: "karachi", label: "Karachi" },
    { value: "lahore", label: "Lahore" },
    { value: "islamabad", label: "Islamabad" },
    { value: "rawalpindi", label: "Rawalpindi" },
    { value: "faisalabad", label: "Faisalabad" },
    { value: "multan", label: "Multan" },
    { value: "peshawar", label: "Peshawar" },
    { value: "quetta", label: "Quetta" },
    { value: "sialkot", label: "Sialkot" },
    { value: "gujranwala", label: "Gujranwala" },
  ];

  return (
    <div className="z-50 ">
      <div
        className="flex relative w-full justify-between
 items-center lg:justify-between lg:items-center px-2 md:px-8  md:py-4 max-w-[1480px] mx-auto  z-20 bg-white "
      >
        <div className="px-2 ">
          <Link to="/">
            <img
              src="/assets/logos/rebhub_main.png"
              alt="rebhub"
              className="w-[90px] md:w-[150px]"
            />
          </Link>
        </div>
        <div
          className={`${humbugerclass} z-[100] md:hidden`}
          onClick={(e) => {
            burgerAnimation(e);
          }}
        >
          <svg id="icon" viewBox="0 0 800 600" fill="#">
            <path
              d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200"
              className="paths "
              id="top"
            ></path>
            <path d="M300,320 L540,320" className="paths" id="middle"></path>
            <path
              d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190"
              className="paths"
              id="bottom"
              transform="translate(480, 320) scale(1, -1)         translate(-480, -318) "
            ></path>
          </svg>
        </div>
        <div className="hidden md:block">
          <List listItem={pages} />
        </div>
        <div
          className={`absolute md:hidden top-0 right-0 bg-[#f5f5f5] w-full min-h-[100vh] transition-all duration-300 ease-in-out  ${
            reponisveMenu ? "translate-x-[0px]" : " translate-x-[1400px] "
          }`}
        >
          <ul className="flex justify-start items-start   w-full px-2  -mb-[12px] lg:gap-4  z-50  flex-col lg:flex-row   ">
            {pages?.map((item, index) => {
              return (
                <>
                  <Link to={item?.url}>
                    <li
                      key={index}
                      className={` p-2 relative    group text-[12px] lg:text-[14px]   cursor-pointer ${
                        activepage === item.name
                          ? " text-[#009932] "
                          : `text-[#333333] hover:text-[#009932] transition-all duration-500 ease-in-out `
                      }`}
                    >
                      <div className="relative group z-40 ">
                        <div className="flex justify-center items-center   ">
                          <p className=" tracking-wide whitespace-nowrap ">
                            {item.name}
                          </p>
                          {item.items?.length > 0 && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                              class="ml-1 -mr-1 h-4 w-4 "
                            >
                              <path
                                fill-rule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                          )}
                        </div>
                        {item.items?.length > 0 && (
                          <div className="absolute invisible group-hover:visible top-6 border flex flex-col rounded-lg px-2 py-4 shadow-md bg-white  text-[14px] text-[#333333] z-20  ">
                            {item.items?.map((item, index) => {
                              return (
                                <Link to={item?.url}>
                                  <p
                                    key={index}
                                    className="p-2 rounded-lg min-w-[170px] hover:bg-[#f5f5f5]"
                                  >
                                    {item.name}
                                  </p>
                                </Link>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </li>
                  </Link>
                </>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Header;

//
//       <div>
//         <div
//           className="flex relative w-full justify-between
//  items-center lg:justify-between lg:items-end  md:px-8 lg:px-16 py- lg:py-4 max-w-[1480px] mx-auto border-b-2 border-[#009932] z-20 bg-white/90 "
//         >
//           <div
//             className={`${humbugerclass} z-[100] md:hidden`}
//             onClick={() => burgerAnimation()}
//           >
//             <svg id="icon" viewBox="0 0 800 600">
//               <path
//                 d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200"
//                 className="paths "
//                 id="top"
//               ></path>
//               <path d="M300,320 L540,320" className="paths" id="middle"></path>
//               <path
//                 d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190"
//                 className="paths"
//                 id="bottom"
//                 transform="translate(480, 320) scale(1, -1)         translate(-480, -318) "
//               ></path>
//             </svg>
//           </div>
//           <div className="px-2 ">
//             <img
//               src="/assets/logos/rebhub.png"
//               alt="rebhub"
//               className="w-[70px] md:w-[100px]"
//             />
//           </div>
//           <div className="hidden lg:block">
//             <List listItem={pages} />
//           </div>
//           <div className="md:flex gap-4 hidden">
//             <Button isbg={false} buttonText={"Signin"} />
//             <Button isbg={true} buttonText={"Join"} />
//           </div>
//           <div className="md:hidden">
//             <svg
//               width="25"
//               height="25"
//               viewBox="0 0 20 20"
//               className="flex justify-center items-center"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 fill-rule="evenodd"
//                 clip-rule="evenodd"
//                 d="M4.50655 0C2.01765 0 0 2.02561 0 4.52433C0 7.02304 2.01765 9.04865 4.50655 9.04865C5.58762 9.04865 6.57978 8.66649 7.3563 8.02939L11.1443 11.8519C11.3393 12.0487 11.6564 12.0495 11.8524 11.8537C12.0485 11.6579 12.0493 11.3396 11.8542 11.1427L8.05706 7.31101C8.65605 6.54289 9.0131 5.57547 9.0131 4.52433C9.0131 2.02561 6.99545 0 4.50655 0ZM1.00146 4.52433C1.00146 2.58088 2.57074 1.00541 4.50655 1.00541C6.44236 1.00541 8.01165 2.58088 8.01165 4.52433C8.01165 6.46777 6.44236 8.04325 4.50655 8.04325C2.57074 8.04325 1.00146 6.46777 1.00146 4.52433Z"
//                 fill="#000000"
//               />
//             </svg>
//           </div>
//         </div>
//       </div>

//       <div className="relative    py-[10vh]  z-20 text-shadow px-4 lg:px-0">
//         <div className="bg-white max-w-[600px] p-4 shadow-xl mx-auto lg:mx-0">
//           <p className="text-center text-[25px] md:text-[30px] leading-10   lg:text-[35px] font-bold    drop-shadow-2xl font-[EurostileBold] ">
//             Pakistan Latest And Emerging{" "}
//             <span className="text-[#009932]"> Realestate Bussiness Hub</span>
//           </p>
//           <p className="text-center  text-[16px] md:text-[22px]   lg:text-[25px] pt-4  drop-shadow-xl">
//             Find your new home.
//           </p>
//           <p className="text-center  text-[16px] md:text-[22px]   lg:text-[25px]    ">
//             Search properties for sale and rent
//           </p>
//         </div>
//         <div className="bg-[#009932] p-6 flex flex-wrap lg:flex-nowrap justify-center items-center gap-2 mt-8 lg:mt-20 mx-4 rounded-sm">
//           <p className=" tracking-wide ">vgvgv</p>

//           {/* <Select options={options} className="min-w-[250px] w-full " />
//           <Select options={options} className="min-w-[250px]  w-full" />
//           <Select options={options} className="min-w-[250px]  w-full" />
//           <Button isbg={false} buttonText={"Buy"} bgcolor={"bg-[#ffff00]"} />
//           <Button isbg={false} buttonText={"Rent"} bgcolor={"bg-[#ffff00]"} /> */}
//         </div>
//       </div>

// <div className="absolute  top-0 z-0 w-full">
//   <div className="absolute top-0 z-0 w-full h-full bg-black opacity-60"></div>
//   <img
//     src="/assets/images/villa.jpeg"
//     alt=""
//     className=" min-h-[100vh] max-w-[1480px] mx-auto h-full w-full"
//   />
// </div>
//     </div>
